import { Selector } from "@ngxs/store";
import { YearsState, YearsStateModel } from "./years.state";

export class YearsGetterState {
  @Selector([YearsState])
  static getYearsList(state: YearsStateModel) {
    return state.years;
  }
}